import { Component, OnInit, ViewChild, ElementRef, NgZone, AfterViewInit } from '@angular/core';
import { faSlidersH, faMapMarkerAlt, faPhone, faMapPin, faPen, faInfo, faGlobeAmericas, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { MatPaginator } from '@angular/material/paginator';
import { DomSanitizer } from '@angular/platform-browser';
import { map, startWith } from 'rxjs/operators';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AgmInfoWindow, AgmMap, LatLngLiteral, MapsAPILoader } from '@agm/core';
import { stringify } from 'querystring';
import { Observable, zip } from 'rxjs';
import { RadiusDisplayService } from 'src/app/Services/radius-display.service';
import { RadiusSearchSettings } from 'src/app/models/RadiusSearchSettings';
import { GeoCodeService } from 'src/app/Services/geo-code.service';
import { GenericEntityData, PagedResult, QueryDefinitionData, VirtualFileData } from '../../interfaces/asi.interfaces';
import { IqaService } from 'src/app/Services/iqa.service';
import { PartyImageService } from 'src/app/Services/party-image.service';
import { VersionService } from 'src/app/Services/version.service';
import { ContentObserver } from '@angular/cdk/observers';
import { __core_private_testing_placeholder__ } from '@angular/core/testing';
import { ChangeDetectorRef } from '@angular/core';
import { GoogleMapsConfig } from 'src/app/app.module';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { ThrowStmt } from '@angular/compiler';
import { AgmCoreModule  } from '@agm/core';
declare var jQuery: any;
declare var $: any;
@Component({
  selector: 'app-radius-search-display',
  templateUrl: './radius-search-display.component.html',
  styleUrls: ['./radius-search-display.component.scss','./megaMenu.css']
})
export class RadiusSearchDisplayComponent implements OnInit, AfterViewInit {
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;
  @ViewChild('surroundingDiv', { static: false }) surroundingDiv: ElementRef;
  @ViewChild('repeaterDiv', { static: false }) repeaterDiv: ElementRef;
  @ViewChild('googleMap', { static: false }) public googleMap: ElementRef;
  @ViewChild('searchField', { static: false }) searchField: ElementRef;
  isRadius=false;
  isMap=false
  sendPostCode= false;
  isSendReferal= true;
  clearTime: any;
  imagedataType: any;
  mapAPIkeyReady= false;
  repeatItems = new Array();
  NoData: Boolean;
  faSlidersH = faSlidersH;
  faMapMarkerAlt = faMapMarkerAlt;
  faPhoneAlt = faPhone;
  faMapPin = faMapPin;
  faPen = faPen;
  faInfo = faInfo;
  faGlobeAmericas = faGlobeAmericas;
  faInfoCircle = faInfoCircle;
  isMegaSearchFilter: Boolean = false;
  SuburbOrPostcode = new FormControl();
  CitySuburbPostcode = new Array();
  filteredOptions: Observable<string[]>;
  radius = new Array();
  isAdvancedSearchFilter: Boolean = false;
  isSearchFilter: Boolean = false;
  centerLat: number = -25;
  centerLng: number = 134;
  zoom: number = 8;
  errorMessage: any;
  firstMap = false
  megaFilter=[]
  isFitBound: boolean;
  currentIW: AgmInfoWindow;
  previousIW: AgmInfoWindow;
  resultSection = 1;
  timeout: any = null;
  settings = new RadiusSearchSettings();
  SearchFilters = new Array();
  AdvanceSearchFilters = new Array();
  checkIsValid: Boolean = false;
  citySuburbRadius: String = '';
  defaultPageSize: number = 10;
  currentPage = 0;
  pageSize = 0;
  radiusSearchResultData = new Array();
  postcodeSuburbResults = new Array();
  ZipCodesForRadiusAndPostcodes = new Array();
  sortDistance = {};
  isSortDistance=false;
  recordsBigArray = new Array();
  recordsFilteringArray = new Array();
  matSpinLoader = false;
  searchAdvanceFilter: string = '';
  searchAdvanceFilterChips: boolean = false;
  stateAdvancedCtrl: string = "";
  SurroundingHTML = "<div id='innerDiv'></div>";
  IqaPagedParameters: any;
  isShowOrHide: Boolean;
  blurValidation: boolean;
  returnURL: any;
  countries = [];
  tempSubMegaMenu=[]
  defaultImagePath: string = "https://pseudo-imis.s3-ap-southeast-2.amazonaws.com/RadiusSearchDisplay/assets/PictureLogo.png";
  contactFieldIsID: boolean = false;
  public languageMultiSimpleCtrl = new Array();
  public stateSimpleCtrl = new Array();
  public interestsMultiSimpleCtrl = new Array();
  public languageMultiAdvancedCtrl = new Array();
  public interestsMultiAdvancedCtrl = new Array();
  selectedOption;
  DisplayViewData = []
  checkboxID=[]
  megaMenu=[
    {
      name: 'First',
      subMenu: ['Tabs','Accordion','Text'],
      count:0
    },
    {
      name: 'Second',
      subMenu: ['Card','Title','Team']
      ,count:0
    },
    {
      name: 'Third',
      subMenu: ['Feature','Testimonial','Price'],
      count:0
    }
  ]
  totalMenuCount=0;
  megaMenuLimit=30;
  selectMegaMenu=[]
  map: google.maps.Map;
  radiusParameter: any = 10;
  output: any;
  countryCode: any;
  latValue: any;
  lngValue: any;
  blurValidation2: boolean;
  private imageData = new BehaviorSubject<any>('')
  imageDatas = this.imageData.asObservable();
  rHTML = "&lt;div class=&quot;col-lg-4 col-sm-6 mb-sm-4 mb-3&quot;&gt;&lt;div class=&quot;card-inner&quot;&gt;&lt;div class=&quot;media-heading text-center&quot;&gt;&lt;div class=&quot;img-wrap d-flex align-items-center justify-content-center&quot;&gt;&lt;img alt=&quot;[[FullName]]&quot; class=&quot;img-fluid&quot; src=&quot;[[PictureLogo]]&quot; /&gt;&lt;/div&gt;&lt;/div&gt;&lt;div class=&quot;data-wrap p-2 p-sm-3 p-md-4&quot;&gt;&lt;div class=&quot;data-spec mb-2 mb-sm-3 text-center&quot;&gt;&lt;h4 class=&quot;m-0&quot;&gt;[[FullName]]&lt;/h4&gt;&lt;!--&lt;p class=&quot;m-0&quot;&gt;[[Company]]&lt;/p&gt;--&gt;&lt;/div&gt;&lt;div class=&quot;speciality mb-2 mb-sm-3 text-center&quot;&gt;&lt;p class=&quot;m-0&quot;&gt;&lt;strong&gt;Mobile: &lt;/strong&gt; [[Mobile]]&lt;/p&gt;&lt;p class=&quot;m-0&quot;&gt;&lt;strong&gt;Company: &lt;/strong&gt;[[Company]]&lt;/p&gt;&lt;p class=&quot;m-0&quot;&gt;[[FullAddress]]&lt;/p&gt;&lt;/div&gt;&lt;div class=&quot;phone-map row form-row pt-md-3 pt-2&quot;&gt;&lt;div class=&quot;col-sm-12 text-center&quot;&gt;&lt;a class=&quot;mx-1 fab-orng iconParentClass&quot; onmouseenter=&quot;callOpenGoogleMap(event,[[mapID]])&quot; title=&quot;[[FullAddress]]&quot;&gt;&lt;i class=&quot;iconClass fa fa-map-marker&quot;&gt;&lt;/i&gt;&lt;/a&gt;&lt;p class=&quot;mx-1 fab-orng iconParentClass&quot; title=&quot;[[Mobile]]&quot;&gt;&lt;i class=&quot;iconClass fa fa-phone&quot;&gt;&lt;/i&gt;&lt;/p&gt;&lt;a class=&quot;ml-1 mb-1 btn btn-primary map-button view-details-button&quot; href=&quot;/mbrr/profile?Id=[[ID]]&quot; target=&quot;_blank&quot;&gt;View Details&lt;/a&gt;&lt;/div&gt;&lt;/div&gt;&lt;/div&gt;&lt;/div&gt;&lt;/div&gt;"
  mapAPIkeyfound: boolean
  successMsg= ''
  isSuccessMsg=false
  paramFilters={}
  googleInputCityValue=''
  referralGroup: FormGroup
  sortByDistancePostCode: any=[]
  constructor(private cdRef: ChangeDetectorRef, private radiusDisplayService: RadiusDisplayService, private geocodeService: GeoCodeService, public zone: NgZone,
    private sanitizer: DomSanitizer,
    private mapsAPILoader: MapsAPILoader,
    // public mapkey: GoogleMapsConfig,
    private ngZone: NgZone, private _sanitizer: DomSanitizer,
    private iqaService: IqaService,
    private partyImageService: PartyImageService,
    private versionService: VersionService,
    public fb: FormBuilder

  ) {

    console.log('03-Oct-2023')

  }
  calledFromOutside(newValue: String) {
    this.zone.run(() => {

    });
  }
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.centerLat = position.coords.latitude;
        this.centerLng = position.coords.longitude;
      });
    }
  }
  citySuburbRadiuschange(event) {

    this.radiusParameter = event;
    this.getPostalCode()

  }
  ngOnInit() {
    $(document).click((event) => {
       
        if($(event.target).closest('#megaDropClose').context.className=='far fa-times-circle'){
         

        }else if (!$(event.target).closest('#megaDropClose').length) {

       
        
         
          
            this.isMegaSearchFilter=false
         
       
       
      }else{
       
       
        // this.isMegaSearchFilter=true
      }
    });
      $(document).on('change', 'input[type="checkbox"]',resp =>{
          //do your stuff here
          
      
          if(resp.target.id.includes('checkbox-')){

            if(this.checkboxID && this.checkboxID.length >0  ){
              let ischeck=true
              this.checkboxID.forEach((element,index) => {
                 
                  if(element == resp.target.id ){
                    this.checkboxID.splice(index,1)
                    ischeck = false
                  } 
              });
              if(ischeck)
              this.checkboxID.push(resp.target.id)
              
            }else{
             
              this.checkboxID.push(resp.target.id)
            } 
          }
          
      });
    this.imageData.subscribe(value => {
      
      setTimeout(() => {
        
        if (this.settings && this.settings.displayLayout && this.settings.displayLayout != "") {
          jQuery('#innerDiv').append(this.repeaterDiv.nativeElement);
          let search_results = '';
          jQuery('.removeMeParent .removeMe').each(function () {
           
            search_results = search_results + jQuery(this).html();
          });
          jQuery('#innerDiv').html(search_results);
        }
        if(this.checkboxID && this.checkboxID.length >0){
          this.checkboxID.forEach(element => {
            $('#'+element).attr('checked', true)
          });
         
        }
      }, 500);
    })
    this.versionService.getVersion().subscribe((version: string) => {
      var parts = version.split(".");
      let minor = Number(parts[2]);
      let major = Number(parts[0]);
      if (major == 100) {
        this.contactFieldIsID = false;
      } else {
        this.contactFieldIsID = true;
      }
    },
      err => {
        console.log('Error getting iMIS version.');
      },
      () => {
      })
    let firstcoutn = 0;
    this.SuburbOrPostcode.valueChanges.subscribe(value => {
      if (value) {
        this.blurValidation = true;
      }


    })
    // let first=0
    this.radiusDisplayService.showGoogleKeyMaps.subscribe(value=>{
    
      if(value ){
       
        this.loadDefaultData(value);
      }
      // first++;
    })
    // this.loadDefaultData()
    var a = new Date().getTimezoneOffset();
  }


  ngAfterViewInit(): void {
  
  }



  resetDefault(){
    this.isSearchFilter = false;
    this.isAdvancedSearchFilter = false;
    this.searchAdvanceFilter = "";
    this.SurroundingHTML = "<div id='innerDiv'></div>";
    this.DisplayViewData = [];
    this.recordsBigArray = [];
    this.recordsFilteringArray = [];
    this.matSpinLoader = false;
    this.repeatItems = [];
    this.isFitBound = false;
    this.checkIsValid = false;
    this.selectMegaMenu=[]
    this.totalMenuCount=0
    this.isShowOrHide=false;
    this.SuburbOrPostcode.reset();
    this.getCountryMap()
    this.mapAPIkeyReady=true;
    this.NoData=false
    this.checkboxID=[]
    // this.SearchFilters['searchFilterValues']=[]
    this.SearchFilters.forEach(resp=>{
      
      if(resp.searchFilterValues){
        resp.searchFilterValues =[]
      }else {
        resp.value=""
      }
      
    })
    this.AdvanceSearchFilters.forEach(resp=>{
      
      if(resp.searchFilterValues){
        resp.searchFilterValues =[]
      }else {
        resp.value=""
      }
      
    })
    if(this.settings.EnableEmail){
      this.referralGroup= this.fb.group({
        fName:['',Validators.required],
        lName: [''],
        postalAdd: [''],
        suburb:[''],
        pincode: [''],
        email: ['',[Validators.required,Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i)]],
        isPrintOut: [false],
        PhoneNumber:['']

      })
      this.referralGroup.get('isPrintOut').valueChanges.subscribe(val=>{
       
        if(val){
          this.referralGroup.get('email').clearValidators()
          this.referralGroup.get('email').updateValueAndValidity()

        }else{
          this.referralGroup.get('email').setValidators([Validators.required,Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i)])
          this.referralGroup.get('email').updateValueAndValidity()
        }
      })

      this.referralGroup.valueChanges.subscribe(val=>{
        
        if(this.referralGroup.status=='VALID'){
          
          this.isSendReferal=false
        }else{
          this.isSendReferal=true
        }
      })

     
      
    }
   
  }
  async loadDefaultData(x) {
    this.isSearchFilter = false;
    this.isAdvancedSearchFilter = false;
    this.searchAdvanceFilter = "";
    this.SurroundingHTML = "<div id='innerDiv'></div>";
    this.DisplayViewData = [];
    this.recordsBigArray = [];
    this.recordsFilteringArray = [];
    this.matSpinLoader = false;
    this.repeatItems = [];
    this.isFitBound = false;
    this.checkIsValid = false;
    this.selectMegaMenu=[]
    this.totalMenuCount=0
    this.isShowOrHide=false;
    this.SuburbOrPostcode.reset();
    this.getCountryMap()
    
    // this.radiusDisplayService.getSettings().subscribe(x => {
      
      this.countries = []
      this.settings = x;
       if(this.settings.EnableEmail){
        this.referralGroup= this.fb.group({
          fName:['',Validators.required],
          lName: [''],
          postalAdd: [''],
          suburb:[''],
          pincode: [''],
          email: ['',[Validators.required,Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i)]],
          isPrintOut: [''],
          PhoneNumber:['']

        })
        this.referralGroup.get('isPrintOut').valueChanges.subscribe(val=>{
         
          if(val){
            this.referralGroup.get('email').clearValidators()
            this.referralGroup.get('email').updateValueAndValidity()

          }else{
            this.referralGroup.get('email').setValidators([Validators.required,Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i)])
            this.referralGroup.get('email').updateValueAndValidity()
          }
        })
        this.referralGroup.valueChanges.subscribe(val=>{
          
          if(this.referralGroup.status=='VALID'){
            
            this.isSendReferal=false
          }else{
            this.isSendReferal=true
          }
        })
      }

      if(this.settings && this.settings.withoutRadius && (this.settings.withoutRadius == 'true'  || JSON.parse(this.settings.withoutRadius) == true)){
        this.isRadius = true
      }else{
        this.isRadius = false
      }

      if(this.settings && this.settings.isHideMap ){
        this.isMap = true
        this.mapAPIkeyReady=false;
      }else{
        this.isMap = false
        this.mapAPIkeyReady=true;
      }
      
     
      this.countries.push(this.settings.Country)
      let getCoutnry= this.getCountryMap();
        const searchField = <HTMLInputElement>document.getElementById('txtLocationSearchField');
        const options = {
          componentRestrictions: {
            country: 
              this.countries && this.countries[0] ?
              this.countries[0] == 'Australia' || this.countries[0] == 'AU' ? ['au'] :
                this.countries[0] == 'New Zealand' || this.countries[0] == 'NZ' ? ['nz'] :
                  this.countries[0] == 'Canada' || this.countries[0] == 'CA' ? ['ca'] :
                    this.countries[0] == 'US' || this.countries[0] == 'US' ? ['us'] :
                      this.countries[0] == 'UK' || this.countries[0] == 'GB' || this.countries[0] == 'gb' ? ['uk','gg','je','im'] : ['']

              : ['']
            
          }
          , fields: ["address_components", "geometry", "icon", "name"]
          , strictBounds: true
          , types: ["(regions)"]
        };
       
        this.mapsAPILoader.load().then(() => {
          // this.mapAPIkeyReady=true
          if (searchField && options && options.componentRestrictions && options.componentRestrictions.country && options.componentRestrictions.country[0] && new google.maps.places.Autocomplete(searchField, options)) {
            const autocomplete = new google.maps.places.Autocomplete(searchField, options)
            if (autocomplete) {
              autocomplete.addListener('place_changed', () => {
                var response = autocomplete.getPlace();
                this.googleInputCityValue=response.name
                this.countryCode = 'uk'; // default country, can be: au, ca, gb, nz, us
                this.latValue = response.geometry.location.lat();
                this.lngValue = response.geometry.location.lng();
  
                // loop through address_components to get country code
                for (var i = 0; i < response.address_components.length; i += 1) {
                  var oAddress = response.address_components[i];
                  for (var j = 0; j < oAddress.types.length; j += 1) {
  
                    if (oAddress.types[j] === 'country') { /*outputs result if it is country*/
                      this.countryCode = oAddress.short_name;
  
                    }
                  }
                }
  
                if(!this.isRadius){
                  this.getPostalCode()
                }
              });
              if(!this.isRadius){
                let address=new URLSearchParams(window.location.search).get('address');
                if(address){
                  this.getLatLng(address,options.componentRestrictions.country[0])
                }
              }
              
            }
          } else {
            console.log("country not found")
          }

        })
       
        
      // }, 500);
      this.NoData = false;
      if(this.settings && this.settings.SearchFilters && this.settings.SearchFilters.length && this.settings.SearchFilters.length > 0){
        this.settings.SearchFilters = this.settings.SearchFilters.sort((a, b) => a.Position - b.Position);
      }
      if(this.settings && this.settings.AdvanceSearchFilters && this.settings.AdvanceSearchFilters.length && this.settings.AdvanceSearchFilters.length > 0){
        this.settings.AdvanceSearchFilters = this.settings.AdvanceSearchFilters.sort((a, b) => a.Position - b.Position);
      }
      
      if (typeof (this.settings.ResultsPerPage) != 'number') {
        if (this.settings.ResultsPerPage != "") {
         
          this.settings.ResultsPerPage = parseInt(this.settings.ResultsPerPage ? this.settings.ResultsPerPage : '9')
         
        } else {
          this.settings.ResultsPerPage = 20;
         
        }
      }
      this.loadSettings();
    // });
  }
  
  configureAgmCoreModule(apiKey): void {
    // this.mapsAPILoader.load().then(() => {
    //   // Set the Google Maps API key
    //   (<any>window).google.maps.KEY = apiKey;
    // });
  }

  initializeAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(
      this.searchField.nativeElement
    );

    autocomplete.addListener('place_changed', () => {
      // Handle place selection here
      const selectedPlace = autocomplete.getPlace();
     
    });
  }

  public centerChanged(coords: LatLngLiteral) {
  }


  getLatLng(defaultPlace,countrycode) {
      // var defaultPlace = document.getElementById('autocomplete').value;
      let selectoption={ 'address': defaultPlace,'componentRestrictions': {
        'country': countrycode
    } }
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode(selectoption,  (results, status)=> {
          if (status === google.maps.GeocoderStatus.OK) {
            this.SuburbOrPostcode.setValue(results[0].formatted_address)
              var location = results[0].geometry.location;
              var lat = location.lat();
              var lng = location.lng();
              this.latValue = lat
              this.lngValue = lng
              this.countryCode=selectoption.componentRestrictions.country
              this.getPostalCode()
         
             
          } else {
              console.log("Geocode was not successful for the following reason: " + status);
          }
      });
      
  }

  getPostalCode() {
    if (this.countryCode && this.latValue && this.lngValue && this.radiusParameter) {
      this.blurValidation = false;
      this.cdRef.detectChanges();
      this.ZipCodesForRadiusAndPostcodes = []
      this.sortDistance={}
      let countryCodeValue=this.countryCode.toLowerCase() == 'gg' || this.countryCode.toLowerCase() == 'je' || this.countryCode.toLowerCase() == 'im' ? 'GB' : this.countryCode
      var apiurl = 'https://www.nadeemh.com/pseudocode/radiussearch/geolookup/' + countryCodeValue + '/' + this.latValue + '/' + this.lngValue + '/' + this.radiusParameter + '/';
      const httpcall = new XMLHttpRequest();
      httpcall.open("GET", apiurl);
      httpcall.send();
      httpcall.onreadystatechange = (e) => {
        if (httpcall.readyState == 4 && httpcall.status == 200) {
          var apiresponse = JSON.parse(httpcall.responseText);
          this.output = '';
          this.sortByDistancePostCode=apiresponse
          apiresponse.forEach(result => {
            if (result.postcode != null)
            if(!this.ZipCodesForRadiusAndPostcodes.includes(result.postcode)){
              this.ZipCodesForRadiusAndPostcodes.push(result.postcode)
              this.sortDistance[result.postcode]=result.distance
              
            }
          });
        }
      }
    } else {
      this.blurValidation = true
    }
  }
  clearCheckBox(){
    jQuery(".ncb-inp").attr("checked", false);
    this.megaMenu.forEach(ele=>{
      ele.count =0;
    })
    this.totalMenuCount= 0
    this.selectMegaMenu=[]
  }
  megaMenuTab(i){
   

    $('.is-active').removeClass('is-active');
    
    document.getElementsByClassName('mcbMn-menuLink')[i].classList.add('is-active')
    document.getElementsByClassName('mcbMn-tabContent')[i].classList.add('is-active')
    // document.getElementsByClassName('mcbMn-tabContent')[i].classList.add('tranForm')

    if($(window).width() < 875)

    {
      document.getElementsByClassName('mcbMn-rightCol')[0].classList.add('is-active')
      
     
    } else {
     
      
    }

    
    // jQuery(".mcbMn-menuLink")[i].addClass('.is-active')
  }
  backMegaMenu(){
    $('.mcbMn-rightCol').removeClass('is-active');
  }
  gotChecked(event,i,j){
   
     
    
      
          
      
        if(event.target.checked){
          if(this.megaMenuLimit < this.totalMenuCount+1){
            $('.aTgInp-maxTagsMsg').css('display','block');
            setTimeout(() => {
              $('.aTgInp-maxTagsMsg').css('display','none');
            }, 2000);
            event.stopPropagation();
            event.preventDefault()
          }else{

            this.megaMenu[i]['count']=this.megaMenu[i]['count']+1
            this.totalMenuCount= this.totalMenuCount+1
           
            let data = {row: i,col: j,name: this.megaMenu[i].subMenu[j]}
            this.selectMegaMenu.push(data)
          }
          this.isMegaSearchFilter=true;
        }else{

          this.megaMenu[i]['count']=this.megaMenu[i]['count']-1
          this.totalMenuCount= this.totalMenuCount-1
          this.selectMegaMenu.forEach((ele,index)=>{
      
            if(ele.row== i && ele.col== j){
             
              this.selectMegaMenu.splice(index,1)
            }
          })
          this.isMegaSearchFilter=true;
          $('.selectAllbtn'+i).each((index, element) => {
         
            $(element)[0].checked = false
          }) 
        } 
    
  
    
    
   

  }
  selectAll(event,i){
   
    // if(this.megaMenu[i].subMenu.length < 10){
      if(event.target.checked){
        
        $('.selectAll'+i).each((index, element) => {
         
          $(element)[0].checked = true
          this.megaMenu[i]['count']=index+1
          let data = {row: i,col: index,name: this.megaMenu[i].subMenu[index]}
         
  
  
          var contains = this.selectMegaMenu.some(elem =>{
            return JSON.stringify(data) === JSON.stringify(elem);
          });
  
          if(!contains){
  
            this.selectMegaMenu.push(data)
            this.totalMenuCount= this.totalMenuCount+1
          }
          
          
        })
  
      }else{
        $('.selectAll'+i).each((index, element) => {
         
          $(element)[0].checked = false
          this.megaMenu[i]['count']=0
          let data = {row: i,col: index,name: this.megaMenu[i].subMenu[index]}
         
           this.selectMegaMenu.some((elem,z) =>{
           
            if( JSON.stringify(data) === JSON.stringify(elem)){
             
              this.selectMegaMenu.splice(z,1)
              this.totalMenuCount= this.totalMenuCount-1
            }
          });
  
          
          
        })
      }
    // }
   
  }
  removeMegaMenu(i,j){
   
    let count=0;
    this.megaMenu.forEach((ele,index)=>{
      
      if(index <i){
        ele.subMenu.forEach(ele=>{
          count++;
        })
        
      } 
    })
    let index=count+j
   
    document.getElementById(i+'+'+j)
    document.getElementById(i+'+'+j).click()

   
   
    this.selectMegaMenu.forEach((ele,index)=>{
      
      if(ele.row== i && ele.col== j){
        this.selectMegaMenu.splice(index,1)
        setTimeout(() => {
          
          this.isMegaSearchFilter=true;
        }, 100);
      }
    })


    // this.megaMenu[i]['count']=this.megaMenu[i]['count']-1
    // this.totalMenuCount= this.totalMenuCount-1

  }


  getCountryMap() {
    if (this.countries && !this.isMap)
      this.countries.map((ele, index) => {
       
        if (ele == 'Australia' || ele == 'AU') {
          this.countries[index] = 'AU';
          this.centerLat = -25;
          this.centerLng = 134;
          this.zoom = 4;

          // this.DisplayViewData= [{City:'Uluru',FirstName:'Uluru',lat:this.centerLat,lng:this.centerLng,isSelected:false}];

        } else if (ele == 'New Zealand' || ele == 'NZ') {
         
          this.countries[index] = 'NZ';
          this.centerLat = -42;
          this.centerLng = 172;
          this.zoom = 5;
        } else if (ele == 'Canada' || ele == 'CA') {
          this.countries[index] = 'CA'
          this.centerLat = 57;
          this.centerLng = -101;
          this.zoom = 4;
        } else if (ele == 'United Kingdom' || ele == 'UK' || ele == 'GB') {
          this.countries[index] = 'GB';
          this.centerLat = 54;
          this.centerLng = -2;
          this.zoom = 6;
        } else if (ele == 'United States' || ele == 'US') {
          this.centerLat = 39;
          this.centerLng = -101;
          this.zoom = 4;
        }
        
      });

      return this.countries
  }

  async loadSettings() {
    
    // fetch the city/suburb/zipcodes for auto complete
    if (typeof this.settings.CityZipIQA === 'string' && this.settings.CityZipIQA.length > 0) {
     
      let parameters = new Map<string, string>();
      this.IQAResults(this.settings.CityZipIQA, parameters).then(
        (result: any) => {

          // this.CitySuburbPostcode = result;
          this.SuburbOrPostcode.setValue("");
          // filter for Suburb or postcode
          this.filteredOptions = this.SuburbOrPostcode.valueChanges.pipe(startWith(''), map(value => this._filter(value)));
          // this.SuburbOrPostcode.valueChanges.subscribe(val=>{
          // });
        }
      ).catch(
        error => {

          this.SuburbOrPostcode.setValue("");
        }
      )
    } else {
      
       }

    // fetch the radius for dropdown
    if (typeof this.settings.RadiusIQA === 'string' && this.settings.RadiusIQA.length > 0) {

      let parameters = new Map<string, string>();
      this.IQAResults(this.settings.RadiusIQA, parameters).then(
        (result: any) => {

          this.radius = result;
          if (this.settings.DefaultRadius) {
            this.citySuburbRadius = this.settings.DefaultRadius.toString();
            this.radiusParameter = this.citySuburbRadius

          } else {
            this.citySuburbRadius = "";
            this.radiusParameter = this.citySuburbRadius
          }
        }
      ).catch(
        error => {

          this.citySuburbRadius = "";
          this.radiusParameter = this.citySuburbRadius
        }
      )
    } else { 
      console.log('RadiusIQA is empty.');
     }

    // check the search filters and fetch the data as per the search filters 
    if (this.settings && this.settings.SearchFilters && this.settings.SearchFilters.length &&this.settings.SearchFilters.length > 0) {
      this.SearchFilters = [];
      this.settings.SearchFilters.map((ele, index) => {
        if (ele.FilterType == 'checkedBox' || ele.FilterType == 'freeText') {
          this.SearchFilters[index] = {

            data: ele,
            value: ''
          }
        } else {

          JSON.parse(this.settings.PostcodeZipDropdown).forEach(element => {
            if (ele.SourceIQAParameter == element) {
              let parameters = new Map<string, string>();
              this.IQAResults(ele.IQA, parameters).then(
                (result: any) => {
                 
                  if(ele.FilterType == 'megaMenu'){
                    this.megaMenu = []
                    let obj = {}
                    let count = 0;
                    this.tempSubMegaMenu= result
                    this.megaFilter[index]={
                      type:element,
                      data:this.tempSubMegaMenu
                    }
                    result.forEach(ele => {
                        let flag = 1;
                        if (obj.hasOwnProperty(ele.codeCat)) {
                            this.megaMenu[obj[ele.codeCat]]['subMenu'].push(ele.descSubCat);
                        } else {
                            this.megaMenu.push({
                                name: ele.descCat,
                                subMenu: [ele.descSubCat],
                                count: 0
                            })
                            obj[ele.codeCat] = count;
                            count++;
                        }
                    });
                    this.SearchFilters[index] = {
                      type: element,
                      data: ele,
                      searchFilterValues: this.searchFilterDefaults(ele, result),
                      dropdownData: result,
                      dropdownSettings: this.dropDownSelectChoices(ele.FilterType, ele)
                    }
                  }else{
                    this.SearchFilters[index] = {
                      type: element,
                      data: ele,
                      searchFilterValues: this.searchFilterDefaults(ele, result),
                      dropdownData: result,
                      dropdownSettings: this.dropDownSelectChoices(ele.FilterType, ele)
                    }
                    
                  }
                }
              ).catch(
                error => {
                 
                }
              )
            }
          });
         
        }
       
      })
    } else {
      this.SearchFilters = [];
    }
   

    // check the advance search filters and fetch the data as per the advance search filters

    if (this.settings && this.settings.AdvanceSearchFilters && this.settings.AdvanceSearchFilters.length > 0) {
      this.AdvanceSearchFilters = [];
      this.settings.AdvanceSearchFilters.map((ele, index) => {
        if (ele.FilterType == 'checkedBox' || ele.FilterType == 'freeText') {
          this.AdvanceSearchFilters[index] = {

            data: ele,
            value: ''
          }
        } else {

        JSON.parse(this.settings.PostcodeZipDropdown).forEach((element,eleInde) => {
          
if(eleInde == 0){
  let parameters = new Map<string, string>();
  this.IQAResults(ele.IQA, parameters).then(
    (result: any) => {
      
      this.AdvanceSearchFilters[index] = {
        type: element,
        data: ele,
        searchFilterValues: this.searchFilterDefaults(ele, result),
        dropdownData: result,
        dropdownSettings: this.dropDownSelectChoices(ele.FilterType, ele)
      }
    }
  ).catch(
    error => {
      console.log(ele.FilterLabel, ' ', error.message);
    }
  )
}
        });
      }
      })
    } else {
      this.AdvanceSearchFilters = [];
    }
  }

  private dropDownSelectChoices(selectType, element) {
    let object: any;
   

    if (selectType === 'Single Select' || selectType =='singleselectautocomplete') {
      object = {
        singleSelection: true,
        idField: element.PostcodeValueColumn,
        textField: element.PostcodeDescriptionColumn,
        allowSearchFilter: true,
        closeDropDownOnSelection: true,
        
      }
    } else if (selectType === 'multiselectautocomplete') {
      object = {
        singleSelection: false,
        idField: element.PostcodeValueColumn,
        textField: element.PostcodeDescriptionColumn,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 5,
        allowSearchFilter: true
      }
    }
    return object;
  }

  // set the default values in the dropdowns if any
  private searchFilterDefaults(data: any, dataArr: any) {
   
    let defaultDataArray = [];
    if (data.Defaultvalue !== '') {
      let defaultValues = data.Defaultvalue.split(',');
      for (var i = 0; i < defaultValues.length; i++) {
        dataArr.filter(dataObj => {
          if (dataObj[data.PostcodeValueColumn] === defaultValues[i].trim()) {
            defaultDataArray.push(dataObj)
          }
        })
      }
    }
    return defaultDataArray;
  }

   IQAResults(IQAQuery: string, parameters: Map<string, string>) {
    
    return new Promise((response, reject) => {
     
      //let parameters: Map<string, string> = new Map<string, string>();
      let returnData
      let tempData=[]
    
      this.radiusDisplayService.getIqaResults(IQAQuery, parameters).subscribe(
        async (result: PagedResult) => {
         
          if(result.TotalCount <= 100){
           returnData = this.getTotalData(result)
           response(returnData)
          }else{
            let temp = this.getTotalData(result)
           
            temp.forEach(resp2=>{
              tempData.push(resp2)
            })

            // tempData.push(this.getTotalData(result))
           
            for (let index = 1; index < Math.floor(result.TotalCount/100+1); index++) {
             let offset = index*100
             let arr={}
                await this.IQAResultsTotal(IQAQuery,parameters,offset).then(val=>{
               
                Object.values(val).forEach(ele=>{
                 
                  tempData.push(ele)
                })
                
              })
              // arr.push( await this.IQAResultsTotal(IQAQuery,parameters,offset))
            
             
            }
           
            // setTimeout(() => {
             
              response(tempData)
            // }, 2000);
            
            // this.IQAResults(IQAQuery, parameters)
          }
         
         
         
        }, error => {
          reject(error)
        }
      )
    })
  }

  async IQAResultsTotal(IQAQuery: string, parameters: Map<string, string>,offset: any) {
    return new Promise((response, reject) => {
     
      //let parameters: Map<string, string> = new Map<string, string>();
      let returnData
      this.radiusDisplayService.getIqaResultsOff(IQAQuery, parameters,offset).subscribe(
        (result: PagedResult) => {
          let responseData = new Array();
          let resultSet: GenericEntityData[] = result.Items.$values;
          let columns = [];
          for (var i = 0; i < resultSet.length; i++) {
            let entityData = resultSet[i];
            let rowData = {};
            for (var j = 0; j < entityData.Properties.$values.length; j++) {
              let propData = entityData.Properties.$values[j];
              let name = propData.Name ? propData.Name : '';
              let value = '';
              if (propData.Value) {
                value = typeof (propData.Value) == 'object' ? propData.Value.$value : propData.Value
              }
              if (!columns.includes(name))
                columns.push(name);
              rowData[name] = value;
            }
            responseData.push(rowData);
      
          }
        
          response(responseData)
        }, error => {
          reject(error)
        }
      )
    })
  }


  getTotalData(result){
    let responseData = new Array();
    let resultSet: GenericEntityData[] = result.Items.$values;
    let columns = [];
    for (var i = 0; i < resultSet.length; i++) {
      let entityData = resultSet[i];
      let rowData = {};
      for (var j = 0; j < entityData.Properties.$values.length; j++) {
        let propData = entityData.Properties.$values[j];
        let name = propData.Name ? propData.Name : '';
        let value = '';
        if (propData.Value) {
          value = typeof (propData.Value) == 'object' ? propData.Value.$value : propData.Value
        }
        if (!columns.includes(name))
          columns.push(name);
        rowData[name] = value;
      }
      responseData.push(rowData);

    }
    return responseData
  }

  // filter function for Suburb or postcode
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.CitySuburbPostcode.filter(option => option.Description.toLowerCase().includes(filterValue));
  }

  // get the searched zipcodes locality
  timeouts: any;
  getSearchedZipsData(event) {
    // if(event && event.target && event.target.value ){
    this.selectedOption = undefined;
    let parameters = new Map<string, string>();

    let cityZip = this.SuburbOrPostcode.value;
    this.timeouts = clearTimeout(this.timeouts)
    this.timeouts = setTimeout(() => {
      if (cityZip.length > 2) {
        parameters.set("CityZip", this.SuburbOrPostcode.value);

        //parameters.set("Country","AU");
        this.IQAResults(this.settings.CityZipIQA, parameters).then(
          (result: any) => {
            this.CitySuburbPostcode = result;
          }
        ).catch(
          error => {
            console.log(this.settings.CityZipLabel + ' ' + error.message);
          }
        )
      } else {
        this.CitySuburbPostcode = null;
      }
    }, 300);

    // }

    // let parameters : Map<string,string> = new Map<string,string>();
    // parameters.set('parameter',event.target.value);
    // parameters.set('parameter',this.countries);
    // this.iqaService.getIqaResults(this.settings.CityZipIQA,parameters).subscribe(
    //   (result : PagedResult)=>{
    //     let data = new Array();
    //     for(var i =0;i<result.Items.$values.length;i++){
    //       let entity : GenericEntityData = result.Items.$values[i];

    //       let country = entity.Properties.$values.find(x=>x.Name.toLowerCase()=="country").Value;
    //       let lat = entity.Properties.$values.find(x=>x.Name.toLowerCase()=="latitude").Value;
    //       let lng = entity.Properties.$values.find(x=>x.Name.toLowerCase()=="longitude").Value;
    //       let locality = entity.Properties.$values.find(x=>x.Name.toLowerCase()=="locality").Value;
    //       let zip = entity.Properties.$values.find(x=>x.Name.toLowerCase()=="zip").Value;
    //       let id = entity.Properties.$values.find(x=>x.Name.toLowerCase()=="id").Value;
    //       let zipLocality = entity.Properties.$values.find(x=>x.Name.toLowerCase()=="ziplocality").Value;
    //       data.push({'Locality':locality,'Zip':zip,'Country':country,'Latitude':lat,'Longitude':lng,'id':id,'ZipLocality':zipLocality});
    //     }

    //     this.CitySuburbPostcode=data;
    //     //this.CitySuburbPostcode=result.Items.$values.map(x=>({'Name':x.Properties.$values.Name=="Description"?x.Pr,'Value':x.Properties.Name=="Code"}));
    //     //this.CitySuburbPostcode = result;
    // },
    // err=>{
    // },
    // ()=>{
    // });
    // clearTimeout(this.timeout);

    // var that = this;
    // this.timeout = setTimeout(function () {
    //   that.radiusDisplayService.getZipLocality(that.countries, event.target.value).subscribe(
    //     result => {
    //       that.CitySuburbPostcode = result;
    //     }
    //   );
    //   let parameters : Map<string,string> = new Map<string,string>();
    //   parameters.set('parameter',event.target.value);
    //   parameters.set('parameter',that.countries);
    //   that.iqaService.getIqaResults(that.settings.CityZipIQA,parameters).subscribe(
    //     result=>{
    //       this.CitySuburbPostcode = result;
    //   },
    //   err=>{
    //   },
    //   ()=>{
    //   });
    // }, 400);
  }

  // get the first letter of the first and last name
  getNameFirstLetter(name: String) {
    var matches = name.match(/\b(\w)/g);
    return matches.join(' ');
  }

  // get the tooltip data of the specialInterests
  getTooltipData(specialInterests) {
    if (specialInterests.length > 150) {
      let splicedSpecialInterests = specialInterests.substring(0, 150) + ' ...';
      return splicedSpecialInterests;
    } else {
      return specialInterests;
    }
  }

  // show the clicked info window and closed the previous one
  showInfoWindow(infoWindow, index, m) {

    if (this.previousIW) {
      this.currentIW = infoWindow;
      this.previousIW.close();
    }
    this.previousIW = infoWindow;
    this.DisplayViewData.map(ele => {
      if (ele.mapID == m.mapID) {
        ele.isSelected = true;
      } else {
        ele.isSelected = false;
      }
    })
  }

  // close the opened info window on map
  mapWindowClosed(infoWindow, index, m) {
    this.DisplayViewData.map(ele => {
      if (ele.ID == m.ID) {
        ele.isSelected = false;
      }
    })
  }

  // open the bubble as per the selected record
  openGoogleMapBubble(userID) {
   
    if (this.previousIW) {
      this.previousIW.close();
      this.previousIW = null;
    }
    this.DisplayViewData.map(ele => {
      if (ele.mapID == userID) {
        ele.isSelected = true;
      } else {
        ele.isSelected = false;
      }
    })
  }

  // check whether the dropdown is required and need to throw error to user or not
  validateSearchFilters() {
    let x = false;
    for (var i = 0; i < this.SearchFilters.length; i++) {
      if (this.SearchFilters[i] &&  this.SearchFilters[i].data.IsMandatory  && (this.SearchFilters[i].data.FilterType!='freeText')&& !( this.SearchFilters[i].searchFilterValues.length)) {
        x = true;
      }else if(this.SearchFilters[i] &&  this.SearchFilters[i].data.IsMandatory &&this.SearchFilters[i].data.FilterType=='freeText' && !(this.SearchFilters[i].value) ){
        x=true
      }
     
    }
    return x;
  }

  // fetch the results as per the search button
  ShowResultsSection() {
    setTimeout(() => {
      this.isFitBound = false;
      this.sendPostCode=false
      if (((this.SuburbOrPostcode.value == '' || this.SuburbOrPostcode.value == null || this.citySuburbRadius == '') && !this.isRadius) || this.validateSearchFilters()) {
        this.checkIsValid = true;
        return false;
      } else {
       
        this.SurroundingHTML = "<div id='innerDiv'></div>";
        this.recordsFilteringArray = [];
        this.recordsBigArray = [];
        this.DisplayViewData = [];
        this.repeatItems = [];
        this.matSpinLoader = true;
        this.isSearchFilter = true;
        this.NoData = false;
        this.searchAdvanceFilter = "";
        this.isAdvancedSearchFilter = false;
        this.AdvanceSearchFilters.map(ele => {
          ele.searchFilterValues = [];
        })
        if (this.previousIW) {
          this.previousIW = null;
        }







        let resultsPerPage = this.settings.ResultsPerPage;
        if (this.settings.InputIQA != null) {
         
          this.getUserData(this.settings.InputIQA, 0, resultsPerPage, 'simple');
         
            
            this.getUserData(this.settings.InputIQA, 0, 0, 'advanced');
         
        } else {

        }



        let countryCode = this.CitySuburbPostcode.filter(ele => {
          // if (ele[this.settings.PostcodeValueColumn] == this.SuburbOrPostcode.value) {
          //   return ele.SubstituteValue
          // }
          if (ele.ZipLocality == this.SuburbOrPostcode.value) {
            return ele
          }
        });
        

        return true;

      }
    }, 400);








  }

  

  // fetch the user data from API
  async getUserData(IQAQuery: string, offset: number, pageSize, dataType) {

    
    this.radiusDisplayService.getQueryParameters2(IQAQuery).subscribe(
      (result: any) => {
        
         this.IqaPagedParameters = result;
      })
      JSON.parse(this.settings.PostcodeZipDropdown).forEach(element => {
        
      });
      
      this.getData2018(JSON.parse(this.settings.PostcodeZipDropdown),IQAQuery, offset, pageSize, dataType)
  }

  getData2018(result,IQAQuery: string, offset: number, pageSize, dataType){
    
    // this.IqaPagedParameters = result
    let zipArray = new Array();
    let len = 0;
    let currArray = new Array();

    let megaMenuList;
    if(this.selectMegaMenu && this.selectMegaMenu.length > 0){

      this.selectMegaMenu.forEach(resp=>{
        
        this.tempSubMegaMenu.forEach((elem,x)=>{
         
          if(elem.descSubCat  == resp.name){
              
             
                megaMenuList= megaMenuList ?  megaMenuList+elem.codeSubCat+"," : elem.codeSubCat+","
             
              

          }
        })
       
        
      })
      
    }
    if(megaMenuList)
    megaMenuList= megaMenuList.slice(0, -1)




    if (this.SearchFilters && this.SearchFilters.length > 0) {
      
      this.SearchFilters.forEach(resp => {
        
        if (resp.searchFilterValues && resp.searchFilterValues.length > 0) {
          
          resp.searchFilterValues.forEach(element => {
            
             len +=  element.Code ?  element.Code.length + 9 : element.MemberType.length + 9
            
          });
        }
      })
    }
  
  
    // this.ZipCodesForRadiusAndPostcodes = this.output
    for (var i = 0; i < this.ZipCodesForRadiusAndPostcodes.length; i++) {
      
      let item = this.ZipCodesForRadiusAndPostcodes[i];
  
      len += item.length + 9;
      currArray.push(item);
  
      // if (len >= 1000) {
      //   let zips = currArray.join();
  
      //   // zipArray.push(zips);
      //   currArray = new Array();
      //   // len = 0;
      // }
  
    }
    console.log('length of postal code = ',len)
  
    if (len > 0 || this.isRadius) {
      let zips = currArray.join();
      // zipArray.push(zips);
    }

    let zipParms
    if(len < 1000){
      zipParms=currArray.join()

      let inputString = zipParms;
      // let valuesArray = inputString.split(",");
      // zipParms = valuesArray.map(value => `"${value}"`).join(",");
    }


    let parameters: Map<string, string> = new Map<string, string>();
    
    for (var p = 0; p < result.length; p++) {
      let parmName = result[p];
      if (result[p] == this.settings.PostcodeZipColumn) {
        parameters[parmName] = len <1000 ?zipParms:'';
      } else {
        // if(result[p] == 'TelehealthB')
        // this.SearchFilters.forEach(resp=>{
        // })
        parameters[parmName] = ''
      }
    }
    if(len <1000 ){
      this.sendPostCode=true
    }
    this.SearchFilters.map(ele => {
     
      if (ele && ele['searchFilterValues'] && ele['searchFilterValues'].length > 0) {
        for (var p = 0; p < result.length; p++) {
          let parmName = result[p];
  
          if (ele.type == result[p]) {
  
            parameters[result[p]] = ele['searchFilterValues'].map(function (ele1) { return ele1[ele.data.PostcodeValueColumn]; }).toString();
          }
        }
      } else {
        for (var p = 0; p < result.length; p++) {
  
          let parmName = result[p];
          if (ele.data.SourceIQAParameter == result[p] && ele.value) {
            parameters[result[p]] = ele.value.toString();
          } else {
            // parameters[result.Parameters.$values[p].PropertyName] = '';
          }
        }
      }
    })
    let prevValue = [];

    // this.

    if(this.megaFilter && this.megaFilter.length >0){
      for (var p = 0; p < result.length; p++) {
        this.megaFilter.forEach(fil=>{
          
          if(result[p] == fil.type){
            
            parameters[result[p]]= megaMenuList ?megaMenuList : ''
          }
        })
      }
    }
    

  
    

    var objects = {};
    if(this.SearchFilters && this.SearchFilters.length >0){
      this.SearchFilters.forEach((par,zIndex)=>{
        
        // Object(par.type)
        
        if(par.searchFilterValues && par.searchFilterValues.length >0){
          let tempName
          par.searchFilterValues.forEach(element2 => {
            
            tempName = tempName? tempName+element2[par.dropdownSettings.idField]+',' : element2[par.dropdownSettings.idField]+','
  
          });
          
          if(par.type){

            objects[par.type] = tempName.slice(0, -1)
          }
  
        }else{
         if(par.data.FilterType == 'megaMenu' && this.selectMegaMenu.length>0){
          if(par.type){

            objects[par.type] = megaMenuList
          }
         }else{
           if(par.type){

             objects[par.type] = ""
           }
         }
          
        }

        
        if(par.data.FilterType== "freeText"){
          objects[par.data.SourceIQAParameter]= par.value
        }
        
            
            this.paramFilters=objects

           
          
      })
    }

    if(this.isRadius){
      this.getquery(IQAQuery, zipArray, parameters, offset, pageSize, prevValue, dataType, 0)
    }else{
    
      this.getquery(IQAQuery, zipArray, parameters, offset, pageSize, prevValue, dataType, 0)
      for (let x = 0; x < zipArray.length; x++) {
        if (x == 0) {
          
          this.getquery(IQAQuery, zipArray, parameters, offset, pageSize, prevValue, dataType, x)
        }
      }
    }
  }
  prevCOutnter=0


  getData2017(result,IQAQuery: string, offset: number, pageSize, dataType){
      
      // this.IqaPagedParameters = result
      let zipArray = new Array();
      let len = 0;
      let currArray = new Array();
      if (this.SearchFilters && this.SearchFilters.length > 0) {
        
        this.SearchFilters.forEach(resp => {
          
          if (resp.searchFilterValues && resp.searchFilterValues.length > 0) {
            
            resp.searchFilterValues.forEach(element => {
              
              len +=  element.Code ?  element.Code.length + 9 : element.MemberType.length + 9
              
            });
          }
        })
      }


      // this.ZipCodesForRadiusAndPostcodes = this.output
      
      for (var i = 0; i < this.ZipCodesForRadiusAndPostcodes.length; i++) {
        
        let item = this.ZipCodesForRadiusAndPostcodes[i];

        len += item.length + 9;
        currArray.push(item);

        if (len >= 1000) {
          let zips = currArray.join();

          zipArray.push(zips);
          currArray = new Array();
          len = 0;
        }

      }

      if (len > 0) {
        let zips = currArray.join();
        zipArray.push(zips);
      }
      let parameters: Map<string, string> = new Map<string, string>();
      
      for (var p = 0; p < result.Parameters.$values.length; p++) {
        let parmName = result.Parameters.$values[p].PropertyName;
        if (result.Parameters.$values[p].PropertyName == this.settings.PostcodeZipColumn) {
          parameters[parmName] = 'Zips';//this.ZipCodesForRadiusAndPostcodes.join()
        } else {
          // if(result.Parameters.$values[p].PropertyName == 'TelehealthB')
          // this.SearchFilters.forEach(resp=>{
          // })
          parameters[parmName] = ''
        }
      }
      this.SearchFilters.map(ele => {
        if (ele && ele['searchFilterValues'] && ele['searchFilterValues'].length > 0) {
          for (var p = 0; p < result.Parameters.$values.length; p++) {
            let parmName = result.Parameters.$values[p];

            if (ele.type == result.Parameters.$values[p].PropertyName) {

              parameters[result.Parameters.$values[p].PropertyName] = ele['searchFilterValues'].map(function (ele1) { return ele1[ele.data.PostcodeValueColumn]; }).toString();
            }
          }
        } else {
          for (var p = 0; p < result.Parameters.$values.length; p++) {

            let parmName = result.Parameters.$values[p];
            if (ele.data.SourceIQAParameter == result.Parameters.$values[p].PropertyName && ele.value) {
              parameters[result.Parameters.$values[p].PropertyName] = ele.value.toString();
            } else {
              // parameters[result.Parameters.$values[p].PropertyName] = '';
            }
          }
        }
      })
      let prevValue = [];

      

      for (let x = 0; x < zipArray.length; x++) {
        if (x == 0) {
          
          this.getquery(IQAQuery, zipArray, parameters, offset, pageSize, prevValue, dataType, x)
        }
      }
  }

  async getquery(IQAQuery, zipArray, parameters, offset, pageSize, prevValue, dataType, x) {
    this.matSpinLoader = true;
    
   await this.IQAPagedZipresults(IQAQuery, this.isRadius ? '': zipArray[x], this.settings.PostcodeZipColumn, parameters, offset, pageSize,dataType).then(
      (value: any) => {
        let index = 0;
        value.responseData.forEach(element => {

          element.mapID = element.mapID + index;

          prevValue.push(element)
          index++;
        });
        
        if (value.datatype == 'simple' && !this.settings.RandomizeResults) {

          //we are losing scope of component, generating error.

          prevValue.forEach(element => {

            if (element.ID && element.ID.split('C') && element.ID.split('C').length > 1) {
              element.ID = Number(element.ID.split('C')[2])
            }
          });
          // setTimeout(() => {
          if (x == zipArray.length - 1 || zipArray.length == 0) {
            // this.matSpinLoader = false;
          } else {
            x++;
            this.getquery(IQAQuery, zipArray, parameters, offset, pageSize, prevValue, value.datatype, x)
          }



          const arr1 =  this.getUniqueListBy(prevValue, 'Zip')
          let result=[]
          arr1.forEach((element,i) => {
              Object.keys((this.sortDistance)).forEach((post,j)=>{
                  if(String(element).substring(0, 3) == post.substring(0, 3) && String(element).includes(post) ){
                      result.push(element)
                  }
              })
          })
          let newArr=[]
          result.forEach(element => {
            prevValue.forEach(ele=>{
                  if(element == ele.Zip){
                    let isinclude=newArr.some((val) => { 
                      
                      if(val.ID== ele.ID){
                      // return true
                    } } )
                    
                    if(!isinclude){
                      newArr.push(ele)
                    }
                      
                  }
              })
          });
  
          if(newArr && newArr.length >0){
            this.setSimpleData(newArr.slice(0, this.settings.ResultsPerPage));
          }
        } else if (value.datatype == 'advanced') {
          //we are losing scope of component, generating error.

          if (x == zipArray.length - 1 || zipArray.length == 0) {
            // this.matSpinLoader = false;
          } else {
            x++;
            this.getquery(IQAQuery, zipArray, parameters, offset, pageSize, prevValue, value.datatype, x)
          }
          this.matSpinLoader = true;
          this.recordsBigArray = prevValue;
          this.recordsFilteringArray = prevValue;
         
          const arr1 =  this.getUniqueListBy(prevValue, 'Zip')

          let result=[]
          arr1.forEach((element,i) => {
              Object.keys((this.sortDistance)).forEach((post,j)=>{
                if(this.settings.Country=='US' || this.settings.Country=='AU' || this.settings.Country == 'NZ'){
                  if(String(element).startsWith(post) ){
                    result.push(element)
                  }
                }else{
                  if(String(element).substring(0, 3) == post.substring(0, 3) && String(element).includes(post) ){
                    result.push(element)
                  }
                }
              })
          })
          let newArr=[]
          prevValue.forEach(ele=>{
            result.forEach(element => {
                if(element == ele.Zip){
                  let isinclude=newArr.some((val) => { 
                    if((val.ID== ele.ID && ele.ID!= undefined) || (val.Event== ele.Event && ele.Event!= undefined) ){
                      return true
                    } 
                  })
                  if(!isinclude){
                    newArr.push(ele)
                  }
                }
            })
          });
          if(!this.isRadius){
            this.recordsBigArray=newArr
            this.recordsFilteringArray=newArr
          }
          if (this.settings.RandomizeResults) {
            this.recordsBigArray = this.shuffle(this.recordsBigArray);
             this.setSimpleData(this.recordsBigArray.slice(0, this.settings.ResultsPerPage));
             this.matSpinLoader = false;
          }else if(this.settings.isSortByDistance){
            
            for (let i = 0; i < this.recordsBigArray.length; i++) {
              const element = this.recordsBigArray[i];
              for (let j = 1; j < this.sortByDistancePostCode.length; j++) {
                  const postValue = this.sortByDistancePostCode[j];
                  if((element.City &&  element.City.toLowerCase()) ==(postValue.location && postValue.location.toLowerCase())){
                      this.recordsBigArray[i] = {...this.recordsBigArray[i],...{distance: this.sortByDistancePostCode[j].distance}}
                      break
                  }else if(j==this.sortByDistancePostCode.length-1){
                      for (let z = 1; z < this.sortByDistancePostCode.length; z++) {
                          const undefinedValue = this.sortByDistancePostCode[z];
                          if((element.Zip == undefinedValue.postcode) || ( (this.countryCode.toLowerCase()=='uk' || this.countryCode.toLowerCase()=='gb' || this.countryCode=='ca') && element.Zip.includes(undefinedValue.postcode))){
                              this.recordsBigArray[i] = {...this.recordsBigArray[i],...{distance: this.sortByDistancePostCode[z].distance}}
                              break;
                          }
                      }
                  }
              }
            }
            this.recordsBigArray.sort(function (a, b) {
              return a['distance'] - b['distance'];
            });
            this.setSimpleData(this.recordsBigArray.slice(0, this.settings.ResultsPerPage));  
            this.matSpinLoader = false; 
          }else{

            this.setSimpleData(this.recordsBigArray.slice(0, this.settings.ResultsPerPage));
             this.matSpinLoader = false;
          }
        }
      }
    ).catch(
      error => {
        console.log(error.message);
      }
    )
  }

  goFirst() {
    var r = [];
  
    this.recordsBigArray.forEach((e) => {
      if ((e['City']).toLowerCase() == this.googleInputCityValue.toLowerCase())
        r.unshift(e);
      else
        r.push(e);
    })
  
    return r;
  }

getUniqueListBy(arr, key) {
    return [...new Map(arr.map((item,i) => [item[key], item['Zip']])).values()]
}

  

  // setProfileImages() {
  //   clearTimeout(this.clearTime)

  //   this.DisplayViewData.map((ele, index) => {

  //     this.clearTime= setTimeout(() => {
  //       var contactKeyName = 'ContactKey';//repplace with this.settings.ContactKeyColumn later
  //       if (this.contactFieldIsID) {
  //         if (this.settings.ContactIDColumn != null && this.settings.ContactIDColumn.length > 0) {
  //           contactKeyName = this.settings.ContactIDColumn.toUpperCase();
  //         }
  //       } else {
  //         if (this.settings.ContactKeyColumn != null && this.settings.ContactKeyColumn.length > 0) {
  //           contactKeyName = this.settings.ContactKeyColumn;
  //         }
  //       }

  //       if (typeof ele !== 'undefined' && typeof ele[contactKeyName] !== 'undefined' && ele[contactKeyName] && ele[contactKeyName].trim() !== '') {
  //         var contactKey = ele['PictureNum'];
          
  //         this.partyImageService.getPartyImagePath2(contactKey).subscribe((res: VirtualFileData) => {
            
  //           var imagePath 
  //           if(res && res['Image'] &&res['Image'].$value &&  res['Image'].$value != 'MA=='){
             
  //             let objectURL = 'data:image/jpeg;base64,' + res['Image'].$value;
  //             this.imagedataType =  objectURL
  //             var imagePath =  this.imagedataType;
  //             if (imagePath.indexOf('default') == -1) {
               
  //               var matchStr = this.defaultImagePath;
  //               if (matchStr && this.repeatItems && this.repeatItems[index] && this.repeatItems[index].indexOf(matchStr)) {
                  
  //                 var pos = this.repeatItems[index].indexOf(matchStr);
                  
  //                 if (pos >= 0) {
                   
  //                   var repeatText = this.repeatItems[index];
  //                   var prefix = repeatText.substring(0, pos);
  //                   var pos2 = pos + matchStr.length;
  //                   var postfix = repeatText.substring(pos2, repeatText.length);
  //                   var newItem = prefix + imagePath + postfix;
  //                   this.repeatItems[index] = newItem;
  //                   console.log('SetPROFILEIMAGE IF')
  //                   this.imageData.next('value')
  //                 }else{
  //                   console.log('SetPROFILEIMAGE ELSE')
  //                   // let matchValue= this.repeatItems[index].split('')
  //                  let str= this.extractFirstText(this.repeatItems[index])
                    
  //                   this.repeatItems[index]= this.repeatItems[index].replace(str,imagePath)
                    
  //                   this.imageData.next('value')
                    
                    
  //                 }
  //               }
  //             }

  //           }else{
              
  //           }
  //         },
  //           err => {
  //           },
  //           () => {
  //           }
  //           )
  //       }
  //       if (index == this.DisplayViewData.length - 1) {
  //         console.log('CHANGE Call')
  //         this.imageData.next('change')
  //       }
  //     }, index * 500);
  //   });
  // }

startAgain=0
startArr=[]
  async setProfileImages2() {
    // clearTimeout(this.clearTime)
    this.startArr=[]
    
    for (let index = 0; index < this.DisplayViewData.length; index++) {
        const ele = this.DisplayViewData[index];
        var contactKeyName = 'ContactKey';//repplace with this.settings.ContactKeyColumn later
        if (this.contactFieldIsID) {
          if (this.settings.ContactIDColumn != null && this.settings.ContactIDColumn.length > 0) {
            contactKeyName = this.settings.ContactIDColumn.toUpperCase();
          }
        } else {
          if (this.settings.ContactKeyColumn != null && this.settings.ContactKeyColumn.length > 0) {
            contactKeyName = this.settings.ContactKeyColumn;
          }
        }

        if (typeof ele !== 'undefined' && typeof ele[contactKeyName] !== 'undefined' && ele[contactKeyName] && ele[contactKeyName].trim() !== '') {
          var contactKey = ele['PictureNum'];
          
        await  this.partyImageService.getPartyImagePath2(contactKey).subscribe(async (res: VirtualFileData) => {
          this.startArr.push(index)
          await this.setUrlImage(res,index)
            
            // var imagePath 
            
          },
            err => {
            },
            () => {
            }
            )
           
            
        }
        
     
      
    }


  }


  async setUrlImage(resp,index){
    if(resp && resp['Image'] &&resp['Image'].$value &&  resp['Image'].$value != 'MA=='){
             
      let objectURL = 'data:image/jpeg;base64,' + resp['Image'].$value;
      this.imagedataType =  objectURL
      var imagePath =  this.imagedataType;
      if (imagePath.indexOf('default') == -1) {
       
        var matchStr = this.defaultImagePath;
        if (matchStr && this.repeatItems && this.repeatItems[index] && this.repeatItems[index].indexOf(matchStr)) {
          
          var pos = this.repeatItems[index].indexOf(matchStr);
          
          if (pos >= 0) {
           
            var repeatText = this.repeatItems[index];
            var prefix = repeatText.substring(0, pos);
            var pos2 = pos + matchStr.length;
            var postfix = repeatText.substring(pos2, repeatText.length);
            var newItem = prefix + imagePath + postfix;
            this.repeatItems[index] = newItem;
          
            this.imageData.next('value')
          }else{
            // let matchValue= this.repeatItems[index].split('')
           let str= this.extractFirstText(this.repeatItems[index])
//  Last update 28/11/2023
            // this.repeatItems[index]= this.repeatItems[index].replace(str,imagePath)

            this.imageData.next('value')
            
            
          }
        }
      }

    }else{
      
    }
  }


  extractFirstText(str){
    
    const matches = str.match(/src="(.*?)"/);

    return matches
      ? matches[1]
      : str;
  }

  checkCity(value) {
  }

  onSelectedOption(isSelected: boolean, id: number) {
    if (isSelected) {
      setTimeout(() => {
        const option = this.CitySuburbPostcode.filter(bt => bt.id == id);
        if (option.length > 0) {
          this.selectedOption = option[0];
          //this.SuburbOrPostcode.setValue(this.selectedOption);
        }
      })
    }

  }

  setSimpleData(value) {

  

    this.DisplayViewData = value;

    if (this.paginator) {
      this.paginator.firstPage();
    }
    this.convertCustomHTML(this.DisplayViewData);


    // setTimeout(() => {
    //   let ele = document.getElementById('agmMapClass')

    //   ele.children[0].attributes[5].value = 'true'
    //   setTimeout(() => {
    //   }, 2000);
    // }, 3000);
    
    if (this.DisplayViewData.length == 1 || this.DisplayViewData.length == 0) {

      this.isFitBound = false;
      this.countries[0] = this.settings.Country;



      if (this.DisplayViewData.length == 0) {

        this.getCountryMap();
        this.errorMessage = " No data found. Please try with a different criteria."
        this.NoData = true;


      } else {
        this.NoData = false;
      }
    } else {

      this.NoData = false;
      this.isFitBound = true

    }
    let displaycount = 0

    if (this.DisplayViewData && this.DisplayViewData.length && this.DisplayViewData.length > 0)
    this.pageChangeLocation[0]=[]
      this.DisplayViewData.map((ele, index) => {
        setTimeout(() => {


          // if(firstCounter == 0){
          if (this.DisplayViewData.length == 1) {
            this.centerLng = value[0].lng
            this.centerLat = value[0].lat
            this.zoom = 4;
          }
          // }
          // firstCounter++

          if (typeof ele !== 'undefined' && typeof ele[this.settings.GoogleAddressColumn] !== 'undefined' && ele[this.settings.GoogleAddressColumn].trim() !== '') {
            if(!this.isMap){
            this.geocodeService.geocodeAddress(ele[this.settings.GoogleAddressColumn])
              .subscribe((locations: any) => {
                if (locations && locations.length > 0) {
                  ele['lat'] = locations[0].geometry.location.lat()
                  ele['lng'] = locations[0].geometry.location.lng()
                  if (this.DisplayViewData.length == 1) {
                    this.centerLat = locations[0].geometry.location.lat()
                    this.centerLng = locations[0].geometry.location.lng()
                    this.zoom = 12;
                  }
                  this.pageChangeLocation[0].push({lat: ele['lat'],lng:ele['lng']})
                }
                else {

                  this.centerLng = value[0].lng
                  this.centerLat = value[0].lat
                }
                document.getElementById('agmMapClass').click();
                // ele.addEventListener('click',  (event)=>{
                //   this.callIndexFunction(event, ele.Id)
                // }) 



              });
            }
          }

        }, index * 500);



      })
  }
  callIndexFunction(event, id) {
    window['angularComponentReference'] = {
      component: this, zone: this.ngZone, openGoogleFunction: (id) => {
        this.openGoogleMapBubble(id)
      }
    };
    event.preventDefault();
  }

  shuffle(array) {
    var currentIndex = array.length;


    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }

  // fetcht the user data to show in the table/card/grid etc
  private IQAPagedZipresults(IQAQuery: string, zipArray, zipParmName: string, parameters, offset, pageSize,datatype) {
   
    return new Promise((response, reject) => {
      
      
      this.radiusDisplayService.getIqaPagedZipResults(IQAQuery, zipArray, zipParmName, parameters, offset, pageSize).subscribe(

        (result: PagedResult) => {
          let responseData = new Array();
          let resultSet: GenericEntityData[] = result.Items.$values;
          let columns = [];

          for (var i = 0; i < resultSet.length; i++) {
            let entityData = resultSet[i];
            let rowData = {};
            for (var j = 0; j < entityData.Properties.$values.length; j++) {
              let propData = entityData.Properties.$values[j];
              let name = propData.Name ? propData.Name : '';
              let value = '';
              if (propData.Value) {
                value = typeof (propData.Value) == 'object' ? propData.Value.$value : propData.Value
              }
              if (!columns.includes(name))
                columns.push(name);
              rowData[name] = value;
            }
            responseData.push(rowData);
          }
          let res= {responseData,datatype}
          response(res);
        }, error => {
          reject(error)
        }
      )
    })
  }

  pageChangeLocation=[[]]
  // custom pagination
  async pageChange(event) {
    if (this.previousIW) {
      this.previousIW.close();
      this.previousIW = null;
    }
    this.DisplayViewData = this.recordsBigArray.slice((event.pageSize * event.pageIndex), (event.pageSize * (event.pageIndex + 1)));
    
    this.convertCustomHTML(this.DisplayViewData);
    if(this.pageChangeLocation && this.pageChangeLocation[event.pageIndex]){
      this.DisplayViewData.map((ele, index) => {
        ele['lat'] = this.pageChangeLocation[event.pageIndex-1][index].lat
        ele['lng'] = this.pageChangeLocation[event.pageIndex-1][index].lng
        document.getElementById('agmMapClass').click();
      })
    }else{
      this.pageChangeLocation.push([])  
      this.DisplayViewData.map((ele, index) => {
        setTimeout(() => {
          if (ele[this.settings.GoogleAddressColumn].trim() !== '') {

            if(!this.isMap){
            this.geocodeService.geocodeAddress(ele[this.settings.GoogleAddressColumn])
              .subscribe((locations: any) => {
                if (locations && locations.length > 0) {
                  ele['lat'] = locations[0].geometry.location.lat()
                  ele['lng'] = locations[0].geometry.location.lng()
                  
                  this.pageChangeLocation[event.pageIndex].push({lat: ele['lat'],lng:ele['lng']})
                }
                document.getElementById('agmMapClass').click();
              });
            }
          }
        }, index * 500);
      })
    }
    
  }

  do(event) {
    event.preventDefault();
  }

  // remove any value from advance search
  removeAdvanceSearchData(mainIndex: string, index: number) {
    this.isFitBound = true
    this.AdvanceSearchFilters[mainIndex].searchFilterValues = this.AdvanceSearchFilters[mainIndex].searchFilterValues.filter((ele, langIndex) => langIndex !== index)
  }

  // advance search toggle data change
  searchToggle(toggleClick) {
    if (toggleClick) {
      this.searchAdvanceFilterChips = true;

      this.getSearchRecords(false);
    }

  }

  counters: number = 0;
  async getSearchRecords(isAdvanced = null) {
    // && this.isAdvancedSearchFilter
  
    if (this.isSearchFilter) {
      let filteredData = [];
      let filteredRecords = [];
      // check for search type and push them in an array
      this.AdvanceSearchFilters.map((advSearchObj, advSearchIndex) => {
        if (this.IqaPagedParameters&& this.IqaPagedParameters['Items'] && this.IqaPagedParameters['Items']['$values'] && this.IqaPagedParameters['Items']['$values'] && this.IqaPagedParameters['Items']['$values'] && this.IqaPagedParameters['Items']['$values']) {
          this.IqaPagedParameters['Items']['$values'].map((paramObj, paramIndex) => {
              advSearchObj.searchFilterValues.map((searchObj, searchIndex) => {
                filteredRecords.push(searchObj[advSearchObj.data.PostcodeValueColumn]);
              })
          })
        }
      })
      // loop through the search type array which was filled in above loop and match the values with actual records array to filter it.
      if (filteredRecords.length) {
        for (var i = 0; i < filteredRecords.length; i++) {
          for (var j = 0; j < this.recordsFilteringArray.length; j++) {
            let IqaPagedParametersFiltered = [];
            // if (this.IqaPagedParameters && this.IqaPagedParameters && this.IqaPagedParameters['Properties'] && this.IqaPagedParameters) {
            let str =   JSON.stringify(this.recordsFilteringArray[j]).toLowerCase()
            if(str.includes(filteredRecords[i].toLowerCase())){
              filteredData.push(this.recordsFilteringArray[j]);
          }
              // this.IqaPagedParameters.map((paramObj, paramIndex) => {
              //   if (this.recordsFilteringArray[j][paramObj.Alias != "" ? paramObj.Alias : paramObj.PropertyName]) {
              //     IqaPagedParametersFiltered.push(String(this.recordsFilteringArray[j][paramObj.Alias != "" ? paramObj.Alias : paramObj.PropertyName]).split(','))
              //   }
              // })
              IqaPagedParametersFiltered.map(ele => {
                if (ele.includes(filteredRecords[i])) {
                  filteredData.push(this.recordsFilteringArray[j]);
                }
              })
            // }
          }
        }

        // provide the filtered data to paging array and display array
        this.recordsBigArray = filteredData;
        this.applyFilter(this.searchAdvanceFilter, false);
        if (this.recordsBigArray.length <= this.settings.ResultsPerPage) {
          this.DisplayViewData = this.recordsBigArray;
          if (this.paginator) {
            this.paginator.firstPage();
          }
          this.convertCustomHTML(this.DisplayViewData);
          this.mapSetting()
          
        } else {
          this.DisplayViewData = [];
          for (var x = 0; x < this.settings.ResultsPerPage; x++) {
            this.DisplayViewData.push(this.recordsBigArray[x]);
          }
          if (this.paginator) {
            this.paginator.firstPage();
          }
          this.convertCustomHTML(this.DisplayViewData);
          this.mapSetting()
          
        }
      } else if (this.searchAdvanceFilter != "") {
        this.applyFilter(this.searchAdvanceFilter, true);
        if (this.recordsBigArray.length <= this.settings.ResultsPerPage) {
          this.DisplayViewData = this.recordsBigArray;
          if (this.paginator) {
            this.paginator.firstPage();
          }
          this.convertCustomHTML(this.DisplayViewData);
          if (this.DisplayViewData && this.DisplayViewData.length && this.DisplayViewData.length == 1) {
            this.isFitBound = false;
            // this.getCountryMap()
          }
          else {
            this.isFitBound = true;
          }
          if (this.DisplayViewData && this.DisplayViewData.length == 0) {
            this.isFitBound = false;
            this.getCountryMap()
          } else {
            this.isFitBound = true;
          }

          this.mapSetting()

        } else {
          this.DisplayViewData = [];
          for (var x = 0; x < this.settings.ResultsPerPage; x++) {
            this.DisplayViewData.push(this.recordsBigArray[x]);
          }
          if (this.paginator) {
            this.paginator.firstPage();
          }
          this.convertCustomHTML(this.DisplayViewData);
          this.mapSetting()
          
        }
      } else if (isAdvanced) {
        let resultsPerPage = this.settings.ResultsPerPage;
        this.DisplayViewData = this.recordsFilteringArray.slice(0, resultsPerPage);
        this.recordsBigArray = this.recordsFilteringArray;
        if (this.paginator) {
          this.paginator.firstPage();
        }
        this.convertCustomHTML(this.DisplayViewData);
        if (this.DisplayViewData && this.DisplayViewData.length && this.DisplayViewData.length > 0) {

          this.mapSetting()

        }
        this.counters++;

      }
    }
  }



  mapSetting() {

    if (this.DisplayViewData.length == 1 || this.DisplayViewData.length == 0) {

      this.isFitBound = false;
      this.countries[0] = this.settings.Country;
      if (this.DisplayViewData.length == 0) {

        this.getCountryMap();
        this.errorMessage = " No data found. Please try with a different criteria."
        //  setTimeout(() => {
        this.NoData = true;
        //  }, 5000);



      } else {
        this.NoData = false;
      }
    } else {

      this.NoData = false;
      this.isFitBound = true

    }
    this.DisplayViewData.map((ele, index) => {

      setTimeout(() => {
        if (ele[this.settings.GoogleAddressColumn].trim() !== '') {
          if(!this.isMap){
          this.geocodeService.geocodeAddress(ele[this.settings.GoogleAddressColumn])
            .subscribe((locations: any) => {
              if (locations && locations.length > 0) {
                ele['lat'] = locations[0].geometry.location.lat()
                ele['lng'] = locations[0].geometry.location.lng()
                if (this.DisplayViewData.length == 1) {
                  this.centerLat = locations[0].geometry.location.lat()
                  this.centerLng = locations[0].geometry.location.lng()
                  this.zoom = 12;
                }
              }
              else {

                // this.centerLng = value[0].lng
                // this.centerLat =  value[0].lat
              }
              document.getElementById('agmMapClass').click();
            });
          }
        }
      }, index * 500);
    })
  }


  // function works once user stop typing in advance search filter input for 2 seconds
  onStopSearchTyping() {
    clearTimeout(this.timeout);
    var that = this;
    this.timeout = setTimeout(function () {
      this.isFitBound = true;

      that.getSearchRecords(true);
      // that.applyFilter(that.searchAdvanceFilter)
    }, 2000);
  }

  async applyFilter(searchAdvanceFilter, isNew = null) {
    if (searchAdvanceFilter.trim().length > 0) {
      let filterSearchRecords = []
      if (isNew) {
        
        this.recordsFilteringArray.filter(ele => {
          if(JSON.stringify(ele).toLowerCase().includes(String(searchAdvanceFilter).toLowerCase()) ){
          
          filterSearchRecords.push(ele)
                          
}
        })
      } else {
        this.recordsBigArray.filter(ele => {

          if(JSON.stringify(ele).toLowerCase().includes(String(searchAdvanceFilter).toLowerCase()) ){
            
            filterSearchRecords.push(ele)
                            
  }
          
        })
      }

      this.recordsBigArray = filterSearchRecords
     
    }
  }

  // get background color for the selected row
  getColor(isSelected: boolean) {
    return isSelected ? 'lightgrey' : '';
  }
  chekcing(event) {

  }
 
  i = 0
  ngAfterViewChecked() {
  }

  unjsonEscape(str): string {
    if (typeof str === 'string' && str.length > 0)
      str = str.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"');
    return str;
  }
  async convertCustomHTML(resultSet) {
    window['angularComponentReference'] = {
      component: this, zone: this.ngZone, openGoogleFunction: (id) => {
        this.openGoogleMapBubble(id)
      }
    };
    
    // if (resultSet.length > 0) {


    // setTimeout(() => {

    this.SurroundingHTML = this.unjsonEscape(this.settings.OpeningHTML);
    let bodyHTML = this.unjsonEscape(this.settings.RepeaterHTML);



    var contactKeyName;
    if (this.contactFieldIsID) {
      if (this.settings.ContactIDColumn != null && this.settings.ContactIDColumn.length > 0) {
        contactKeyName = this.settings.ContactIDColumn.toUpperCase();
      }
      
      this.repeatItems = [];
      for (var i = 0; i < resultSet.length; i++) {
      if(this.settings.images){

         resultSet[i].PictureLogo =  !this.settings.Thumbnail ? this.defaultImagePath: resultSet[i].PictureLogo;
      }
      
        let rowSet = resultSet[i];
        let currHTML = bodyHTML.slice(0, bodyHTML.length);
       
        for (var key in rowSet) {

          let val = rowSet[key].toString();
          let match = '[[' + key + ']]';
          let match2 = '[[' + key.replace(' ', '') + ']]';
          
          //  currHTML = currHTML.replace(match, val.replace("'", "''")) for testing implementation
          currHTML = currHTML.replace(match2, val.replace("'", "\'"));
          // currHTML = currHTML.replace(match, val.replace("'", "''"));
          currHTML = currHTML.replace(match2, val.replace("'", "\'"));
        }
        if (this.contactFieldIsID) {
          let val = rowSet[key].toString();
          let match = '[[' + contactKeyName + ']]';
          // currHTML = currHTML.replace(match, val.replace("'", "''"));
       

        }
       
        
       
        // const fiteredArr = this.filterpipe.transform(currHTML,'html');
        
        if(currHTML.includes('[[simpleSearchFilter]]')){
          
          // .split('[[simpleSearchFilter]]').join('vijay')
          currHTML = currHTML.split('[[simpleSearchFilter]]').join('filters='+ encodeURIComponent(JSON.stringify(this.paramFilters)))
          // let match = '[[simpleSearchFilter]]';
        
          
        }

        // currHTML.includes('href="')
        
        this.repeatItems.push(currHTML);

        // const fiteredArr = this.filterpipe.transform(currHTML,'html');
      }
      if(this.settings.images  && !this.settings.Thumbnail){
        await this.setProfileImages2();
      }
    }
    // }, 1000);
    // }
    setTimeout(() => {

      if (this.settings && this.settings.displayLayout && this.settings.displayLayout != "") {
        jQuery('#innerDiv').append(this.repeaterDiv.nativeElement);
        let search_results = '';
        jQuery('.removeMeParent .removeMe').each(function () {
          search_results = search_results + jQuery(this).html();
        });
        jQuery('#innerDiv').html(search_results);
      }

      if(this.checkboxID && this.checkboxID.length >0){
       
      }
    }, 100);


  }

  // get the class name for dropdowns
  getClassName(searchFilter) {

    if (searchFilter != undefined && searchFilter['data'] != undefined && searchFilter['data']['FilterType'] != undefined) {
      return searchFilter.data.FilterType;
    } else {
      return "";
    }
  }

  clearAllAdvanceFilters() {

   
    this.searchAdvanceFilter = "";
    this.AdvanceSearchFilters.map(ele => {
     
      ele.searchFilterValues = []
    });
    this.searchAdvanceFilter = "";
    this.isFitBound = true
    this.NoData = false
    this.isShowOrHide=false

  }

  getIsclearAllAdvanceFilters() {
   
    let isShowOrHide = false;
    if (this.AdvanceSearchFilters.length > 0) {
      this.AdvanceSearchFilters.map((ele, index) => {
        if (ele && ele.searchFilterValues&& ele.searchFilterValues.length > 0) {
          isShowOrHide = true;
        }
        if (this.AdvanceSearchFilters.length == index + 1) {
          if (isShowOrHide) {
            this.isShowOrHide = true;
            return true;
          } else if (this.searchAdvanceFilter == "") {
            this.isShowOrHide = false;
            return false;
          } else {
            this.isShowOrHide = true;
            return true;
          }
        }
      });
    } else {
      if (this.searchAdvanceFilter != "") {
        this.isShowOrHide = true;
        return true;
      } else {
        this.isShowOrHide = false;
        return false;
      }
    }
  }

  getInputButtonValue() {
    this.returnURL = "/Staff/CreateCommunication?query=" + this.settings.InputIQA + "&queryparams=%5B"; // 1

    JSON.parse(this.settings.PostcodeZipDropdown).map((paramObj, paramIndex) => {
      if (paramObj != 'ID') {
        this.returnURL = this.returnURL + "%7B" + "%22Item1%22%3A%22" + paramObj + "%22%2C%22Item2%22%3A%22%22" + "%7B%2C";
      }
    });

    this.returnURL = this.returnURL + "%7B" + "%22Item1%22%3A%22ID" + "%22%2C%22Item2%22%3A%22";

    this.recordsBigArray.map((ele, index) => {
      if (this.recordsBigArray.length == index + 1) {
        this.returnURL = this.returnURL + "%22" + ele.ID + "%22"
      } else {
        this.returnURL = this.returnURL + "%22" + ele.ID + "%22%2C"
      }
    })

    this.returnURL = this.returnURL + "%22%7B%5D";

    this.returnURL = this.returnURL + "&ReturnUrl=" + window.location.pathname + window.location.search + ";";

    window.location.href = this.returnURL;

    // this.returnURL = this.returnURL + "return CancelEvent();;WebForm_DoPostBackWithOptions(new WebForm_PostBackOptions('ctl01$TemplateBody$WebPartManager1$gwpciDirectory$ciDirectory$PeopleSearch$ButtonEmail', '', true, '', '', false, true))";


  }

  sendReferral(){

var date = new Date();

    
    if(this.referralGroup.status =="INVALID"){
      this.referralGroup.markAllAsTouched();
      
    }else{
      
     this.isSendReferal=true
      

      if(this.checkboxID && this.checkboxID.length >0){
       
        this.checkboxID.forEach((resp,i)=>{
         
          if(resp && resp.split('checkbox-') && resp.split('checkbox-')[1]){
            let payLoad = {
              "$type": "Asi.Soa.Core.DataContracts.GenericEntityData, Asi.Contracts",
              "EntityTypeName": "Public_Referrals",
              
              "Properties": {
                  "$type": "Asi.Soa.Core.DataContracts.GenericPropertyDataCollection, Asi.Contracts",
                  "$values": [
                      {
                          "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                          "Name": "City",
                          "Value": this.referralGroup.get('suburb').value
                      },
                      {
                          "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                          "Name": "Date",
                          "Value":date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate() + " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds()
                          // "Value":new Date()
                      },
                      {
                          "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                          "Name": "Email",
                          "Value": this.referralGroup.get('email').value
                      },
                      {
                          "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                          "Name": "FirstName",
                          "Value": this.referralGroup.get('fName').value
                      },
                      {
                          "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                          "Name": "PartyId",
                          "Value": resp.split('checkbox-')[1]
                      },
                      {
                          "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                          "Name": "LastName",
                          "Value": this.referralGroup.get('lName').value
                      },
                      {
                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        "Name": "PhoneNumber",
                        "Value": this.referralGroup.get('PhoneNumber').value
                      },
                      {
                          "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                          "Name": "PostalAddress",
                          "Value": this.referralGroup.get('postalAdd').value
                      },
                      {
                          "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                          "Name": "Postcode",
                          "Value": this.referralGroup.get('pincode').value
                      },
                      {
                          "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                          "Name": "PrintOnly",
                          "Value": {
                              "$type": "System.Boolean",
                              "$value": this.referralGroup.get('isPrintOut').value ? this.referralGroup.get('isPrintOut').value: false 
                          }
                      },
                      {
                          "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                          "Name": "ReferralType",
                          "Value": "Referral"
                      },
                      {

                        "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                        
                        "Name": "SearchFilters",
                        
                        "Value": JSON.stringify(this.paramFilters)
                        
                        },
                      {
                          "$type": "Asi.Soa.Core.DataContracts.GenericPropertyData, Asi.Contracts",
                          "Name": "SentBy",
                          "Value": "Staff"
                      }
                      
                  ]
              }
          }
    
   
        
    
          this.radiusDisplayService.postData(payLoad).subscribe(resp=>{
           
            if(resp){
    
              if(i == this.checkboxID.length-1){
    
                this.successMsg ="Record is updated successfully"
                this.isSuccessMsg=true;
                setTimeout(() => {
                  this.isSuccessMsg=false
                  this.resetDefault()
                  
                }, 3000);
              }
            }
          })
  
          }
  
        
  
        })
      }


    }
  }


}